import React from 'react';

interface Props {
  className?: string;
  width?: number;
  height?: number;
  color?: string;
}

export const ArrowRight = ({
  className,
  width = 24,
  height = 24,
  color = 'currentColor',
}: Props) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.707 11.3037L14.414 7.01069C14.0216 6.63172 13.3979 6.63714 13.0122 7.02287C12.6264 7.40861 12.621 8.03231 13 8.42469L15.586 11.0107H6C5.44772 11.0107 5 11.4584 5 12.0107C5 12.563 5.44772 13.0107 6 13.0107H15.586L13 15.5967C12.621 15.9891 12.6264 16.6128 13.0122 16.9985C13.3979 17.3842 14.0216 17.3897 14.414 17.0107L18.707 12.7177C19.0974 12.3272 19.0974 11.6942 18.707 11.3037Z"
      fill={color}
    />
  </svg>
);
